var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('SmoothScrollLand',[_c('div',{staticClass:"home home-true",attrs:{"data-scroll-section":"","data-scroll":""}},[_c('router-view'),_c('Footer')],1)]),_c('CookiesBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }